import React from "react";
import "./styles/radarPoints.css";
import LineRadaria from "../../assets/icons/LineRadaria.svg";
import Running from "../../assets/icons/Runner.svg";
import GroupRunner from "../../assets/images/GroupRunners.png";
import ScrollAnimation from "react-animate-on-scroll";
import RunningClub from "../../assets/images/runningsClubsLanding.jpg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ComnmunitiesAndEvents = () => {
  const { userType } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigation = useNavigate();
  const onClick = () => {
    if (isAuthenticated) {
      if (userType === "user") {
        navigation("/dashboard/history");
      } else {
        toast.error(
          "¡Debes iniciar sesión como Runner para acceder a esta sección!"
        );
      }
    } else {
      navigation("/auth");
    }
  };
  return (
    <section className="wrap-radar-points wrap-Rinning-club">
      <div className="wrap-description-radar-points">
        <div>
          <div className="wraper-title-radar-points">
            <img src={LineRadaria} alt="line" width={60} />
            <h2 className="text-white text-center">Clubs de Corredores</h2>
            <img src={Running} alt="" />
          </div>
          <p className="text-white text-center fs-5">
            Correr en grupo te llevará más lejos. Forma parte de una comunidad
            que te impulsa a alcanzar nuevas metas.
          </p>
        </div>
        <div className="container-img-map">
          <img src={GroupRunner} alt="" />
        </div>
      </div>
      <section className="wrap-join-community">
        <ScrollAnimation
          animateIn="fadeIn"
          animateOut="fadeOut"
          className="container-img-map"
          style={{ width: 350 }}
        >
          <img src={RunningClub} alt="" style={{ borderRadius: 20 }} />
        </ScrollAnimation>
        <div className="subwrap-joinCommunity">
          <div className="d-flex flex-column align-items-center">
            <p className="text-white text-center fs-5">
              En los clubs de corredores de Radaria, encontrarás el apoyo, la
              motivación y la camaradería que necesitas para superar tus
              límites. Cada salida, cada meta, cada logro… se celebra en
              comunidad.
            </p>
            <button
              onClick={onClick}
              className={`btn button-link ${`btn-primary active animate__animated animate__pulse animate__infinite infinite `}  m-2 ps-4 pe-4 `}
            >
              ¡Vamos!
            </button>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ComnmunitiesAndEvents;
